import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import type { Types } from '@fiverr-private/theme';
import { DrawerChildrenProps } from '../types';
import { DEFAULT_PADDING_X, DEFAULT_PADDING_Y } from './constants';

interface StylingProps extends Types.GlobalStylingProps, Pick<Types.ContainerProps, 'paddingX' | 'paddingY'> {}

const DrawerFooter = ({
  children,
  paddingX = DEFAULT_PADDING_X,
  paddingY = DEFAULT_PADDING_Y,
  ...restProps
}: DrawerChildrenProps & StylingProps) => (
  <Container
    as="footer"
    position="sticky"
    borderTopWidth="sm"
    borderStyle="solid"
    borderColor="border"
    paddingX={paddingX}
    paddingY={paddingY}
    {...restProps}
  >
    {children}
  </Container>
);

DrawerFooter.displayName = 'DrawerFooter';

export default DrawerFooter;
